<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section">I<br/>B<span class="smallcaps">EFORE</span></h1>
<p class="basic-paragraph"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// thefollowers_00005.vue?70239df2